const setDefault = (key, value) => (key ? key : value);
const envVar = process.env;
export default {
  url: setDefault(envVar.REACT_APP_URL, ""),
  api: setDefault(envVar.REACT_APP_API, ""),
  pgw: setDefault(envVar.REACT_APP_API_PGW, ""),
  api_key: setDefault(envVar.REACT_APP_KEY, ""),

  secretKey: setDefault(envVar.REACT_APP_SECRET, ""),
};
